<template>

    <div
        v-show="routeType"
        class="masthead"
        ref="masthead"
        :style="mastheadStyle"
        zdata-aos="custom-fade-in"
    >
        <div class="container">
            <div class="capper">
                <inline-svg
                    class="home-tt"
                    src="/assets/site/images/tt-flat.svg"
                    aria-label="ARSONAL"
                ></inline-svg>
            </div>
        </div>
    </div>

    <!-- Header container (remains unchanged) :style="headerContainerStyle" -->
    <div v-show="routeType" id="header-container" data-aos="custom-fade-in" :style="headerContainerStyle">
        <header v-if="json" :class="[`route-type-${routeType}`, smallHeader ? 'small' : '']">
            <div class="container">
                <div class="capper">
                    <div class="capper-padded">
                        <div class="flex-content">
                            <div class="r">
                                <div :class="searchClasses"
                                     @focusin="focusSearchOver"
                                     @mouseover="focusSearchOver"
                                     @focusout="focusSearchOut"
                                >
                                    <button id="search-button"
                                            @click="submitSearch"
                                    >

                                        <inline-svg
                                            class="icon"
                                            src="/assets/site/images/search.svg"
                                            aria-label="Searchw"
                                        ></inline-svg>
                                    </button>
                                    <input
                                        ref="searchInput"
                                        id="search"
                                        autocomplete="off"
                                        placeholder="Search..."
                                        @Zinput="debounceSearch"
                                        @keyup.enter="submitSearch"
                                    >
                                </div>
                                <nav class="header-nav">
                                    <ul>
                                        <li
                                            v-for="(item, index) in json.header.nav"
                                            :key="`header-nav-${index}`"
                                        >
                                            <span :class="['dot', { active: isActive(item.link) }]"></span>
                                            <Link
                                                :href="item.link"
                                                :target="item.target"
                                                :label="item.label"
                                                classes=""
                                            />
                                        </li>
                                    </ul>
                                </nav>
                                <div class="ttmotif">
                                    <router-link to="/">
                                        <div class="svg-holder">
                                            <inline-svg
                                                class="tt-motif"
                                                src="/assets/site/images/tt-motif.svg"
                                                aria-label="ARSONAL"
                                            ></inline-svg>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="header-bottom-border">
            <div class="l1"></div>
            <div class="l2"></div>
            <div class="l3"></div>
        </div>
    </div>

</template>

<script>
import {mapState} from 'vuex';
import Link from "@/components/pieces/Link";

export default {
    name: "HeaderComponent",
    components: {
        Link,
    },
    data() {
        return {
            window: window,
            document: document,
            json: null,
            mastheadHeight: '0px', // used for the masthead animation
            isSmallHeader: false,
            mobileNavOpen: false,
            newsNavOpen: false,
            scrollCheckElem: [],
            scrollCheckOverride: true,
            headerTheme: null,
            headerThemeComputedToggler: Math.random(),
            searchTimeout: null,
            searchIsFocused: false,
            naturalHeight: '0px',
            mastheadTransition: '',
            headerContainerTransition: 'none',
        }
    },
    computed: {
        ...mapState({
            routerNextTo: state => state.routerNextTo,
            searchTerm: state => state.searchTerm,
            smallHeader: state => state.smallHeader,
            mobileCloseToggler: state => state.mobileCloseToggler,
        }),
        mastheadStyle() {
            let obj = {
                height: this.mastheadHeight,
                overflow: 'hidden',
                transition: this.mastheadTransition
            }
            return obj
        },
        headerContainerStyle() {
            return {
                transition: this.headerContainerTransition,
            }
        },

        searchClasses() {
            let ret = 'search';
            if (this.searchIsFocused) {
                ret += ' focused';
            }
            return ret;
        },
        routeType() {
            // start route type check as route on page load, or grab from transition
            let rt = this.$route.meta.type
            if (window.config.loadedOnce) {
                if (this.routerNextTo?.meta?.type) {
                    rt = this.routerNextTo?.meta?.type
                }
            }
            return rt
        }
    },
    watch: {
        routerNextTo() {

        },
        smallHeader() {
            this.isSmallHeader = this.smallHeader;
        },
        mobileCloseToggler() {
            this.setMobileNavOpen(false);
        },
        $route(to) {
            this.headerTheme = to.meta.headerTheme;

            // Update body classes
            this.document.body.className = document.body.className
                .split(' ')
                .filter(className => !className.startsWith('route-type'))
                .join(' ');
            this.document.body.className += ' route-type-' + this.routeType;

            this.scrollCheckElem = null;
            this.scrollCheckOverride = false;
            const t = this;
            setTimeout(function () {
                t.scrollCheckElem = t.document.querySelector(".scroll-check-trigger");
                t.headerThemeComputedToggler = Math.random();
                if (!t.scrollCheckElem) {
                    setTimeout(function () {
                        t.scrollCheckElem = t.document.querySelector(".scroll-check-trigger");
                        t.headerThemeComputedToggler = Math.random();
                    }, 500);
                }
            }, 500);

            // if (this.routeType === 'home') {
            //     // this.updateNaturalHeight()
            //     // this.updateMasthead()
            // }

            this.updateNaturalHeight()
            this.updateMasthead()
        },
    },
    mounted() {
        this.json = this.window.config.json.global;
        window.addEventListener('scroll', this.scroll)
        window.addEventListener('keyup', this.detectEscapeKey)
        window.addEventListener('resize', this.updateNaturalHeight)

    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateNaturalHeight)
    },
    methods: {
        updateNaturalHeight() {
            this.$nextTick(() => {
                const container = this.$refs.masthead?.querySelector('.container')
                if (container) this.naturalHeight = `${container.offsetHeight}px`

                const mastheadEl = this.$refs.masthead
                if (!mastheadEl) return

                if (this.routeType === 'home') {                 // ► getting bigger
                    mastheadEl.style.height = this.naturalHeight
                    this.mastheadHeight = this.naturalHeight
                    this.mastheadTransition = 'height 250ms ease-in-out'
                } else {                                         // ► getting smaller
                    mastheadEl.style.height = '0px'
                    this.mastheadHeight = '0px'
                }

                document.documentElement.style.setProperty('--mastheadHeight', this.mastheadHeight)
            })
        },

        updateMasthead() {
            const mastheadEl = this.$refs.masthead
            if (!mastheadEl) return

            if (this.routeType === 'home') {
                mastheadEl.style.height = this.naturalHeight
                this.mastheadHeight = this.naturalHeight
                this.mastheadTransition = 'height 250ms ease-in-out'

            } else {
                mastheadEl.style.height = 0
                this.mastheadHeight = 0

            }

            let t = this
            if (t.mastheadHeight === 0) {
                t.headerContainerTransition = 'all 250ms ease-in-out'
            } else {
                t.headerContainerTransition = 'all 250ms ease-in-out'
                setTimeout(function () {
                    t.headerContainerTransition = 'none'
                }, 250)
            }

        },

        isActive(href) {
            return href === this.$route.path;
        },

        focusSearchOver() {
            this.searchIsFocused = true;
            this.$refs.searchInput.focus();
        },
        focusSearchOut() {
            // Optionally remove focus state here if needed
            this.searchIsFocused = false;
        },
        detectEscapeKey(e) {
            if (e.keyCode === 27) {
                this.setMobileNavOpen(false);
                this.setNewsNavOpen(false);
            }
        },
        scroll() {
            this.$store.commit('setSmallHeader', (window.scrollY > 0));
            if (this.scrollCheckElem) {
                if (window.scrollY >= this.scrollCheckElem.offsetTop - 55) {
                    this.scrollCheckOverride = true;
                } else {
                    this.scrollCheckOverride = false;
                }
            }
        },
        setMobileNavToggle() {
            this.mobileNavOpen = !this.mobileNavOpen;
        },
        setMobileNavOpen(isOpen) {
            this.mobileNavOpen = isOpen;
        },
        setNewsNavOpen(isOpen) {
            this.newsNavOpen = isOpen;
        },
        hamburgerClose() {
            this.setMobileNavOpen(false);
            this.setNewsNavOpen(false);
        },
        hamburgerMultiverseClicker() {
            if (this.newsNavOpen) {
                this.setNewsNavOpen(false);
            } else {
                this.setMobileNavToggle();
            }
        },
        debounceSearch() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                this.submitSearch();
            }, 1500);
        },
        submitSearch() {
            clearTimeout(this.searchTimeout);
            const newSearchTerm = this.$refs.searchInput.value.trim();
            if (newSearchTerm) {
                this.$store.commit('setSearchTerm', newSearchTerm);
                this.$router.push({
                    path: '/search',
                    query: {q: newSearchTerm},
                });
                this.focusSearchOut()
            } else {
                this.focusSearchOver()
            }
        },
    }
}
</script>
<style lang="scss">
.masthead {

}
</style>